import React, { useEffect, useState, useCallback } from 'react';
import { Text } from '@chakra-ui/react';

export type CountdownTimerProps = {
  timeDurationLeft: number;
  doClearInterval?: () => void;
};

const CountdownTimer: React.FC<CountdownTimerProps> = props => {
  const { timeDurationLeft, doClearInterval } = props;
  const [timeLeft, setTimeLeft] = useState(timeDurationLeft);
  const [timerId, setTimerId] = useState<
    ReturnType<typeof setTimeout> | undefined
  >(undefined);

  useEffect(() => {
    setTimeLeft(timeDurationLeft);
  }, [timeDurationLeft]);

  const countDownTimer = useCallback(() => {
    setTimeLeft(prevTime => (prevTime ? prevTime - 1 : 0));
  }, []);

  useEffect(() => {
    const interval = setInterval(countDownTimer, 1000);
    setTimerId(interval);
    return () => clearInterval(interval);
  }, [countDownTimer]);

  useEffect(() => {
    if (timeLeft <= 0) {
      clearInterval(timerId);
      doClearInterval();
    }
  }, [timeLeft]);

  const formatTime = (timeInSeconds: number) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const remainingSeconds = timeInSeconds % 60;

    return `${minutes
      .toString()
      .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return <Text>{formatTime(timeLeft)}</Text>;
};

export { CountdownTimer };
